import './App.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { Footer } from './footer/Footer';
import { Header } from './header/Header';
import { HeaderMobile } from './header/HeaderMobile';
import { isDesktop } from 'react-device-detect';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { Prestations } from './prestations/Prestations';
import { Intro } from './intro/Intro';
import { Contact } from './contact/Contact';
import { About } from './about/About';

function App() {
  return (
    <div className="app">
      {isDesktop ? <Header /> : <HeaderMobile />}
      <>
        <Intro />
        <Prestations />
        <About />
        <Contact />
      </>
      <Footer />
    </div>
  );
}

export { App };
library.add(fab, fas, far);
